export default function range(len: number): number[] {
  return Array.from(Array(len).keys());
}
